import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-UMXZTB3W.mjs";
import "./chunk-TCCFYFTB.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
